export class InternalError extends Error {
	private error: string;
	constructor(message: string, public code: number = 0) {
		super(message);
		this.error = message;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
